"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : HEADER : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  header: {
    background: _index.theme.color.supporting.light.swatch,
    borderBottom: (0, _index.replacePXinStringWithEM)("1px solid #ddd"),
    // boxShadow: replacePXinStringWithEM(`0 1px 0 0 ${theme.boxShadow.bar}`),
    color: _index.theme.color.dark.dark.contrast,
    height: (0, _index.pxToEm)(80),
    width: '100%',
    padding: (0, _index.replacePXinStringWithEM)("0px ".concat(_index.theme.spacing.sides)),
    position: 'relative',
    zIndex: '2',
    // layout
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // animations
    opacity: '0',
    animationName: 'fadeInDown',
    animationDelay: '.1s',
    animationDuration: '.2s',
    animationFillMode: 'forwards',
    // ----- GROUPS ----- //
    '& > .group': {
      // +++++ logo +++++ //
      '&.name-logo': {
        flex: '0',
        paddingRight: (0, _index.pxToEm)(20)
      },
      // +++++ navs +++++ //
      '&.name-navs': {
        flex: '1',
        display: 'flex',
        justifyContent: 'space-between',
        // topnav
        '& .name-sections': {
          flex: '1',
          display: 'flex',
          '& .logo.name-insticator-icon': {
            marginRight: (0, _index.pxToEm)(30)
          }
        },
        // account
        '& .name-account': {
          flex: '0',
          display: 'inline-flex',
          alignItems: 'center',
          fontSize: (0, _index.pxToEm)(15),
          fontWeight: 600,
          position: 'relative',
          transition: 'all .1s ease-out 1s',
          '& .greeting': {
            color: _index.theme.color.supporting.dark.swatch
          },
          '& .username': {
            paddingLeft: (0, _index.pxToEm)(8),
            color: _index.theme.color.primary.medium.swatch,
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            '& .icon': {
              position: 'relative',
              top: (0, _index.pxToEm)(-2)
            }
          },
          '& .link.name-logout, .link.backtooldpanel': {
            color: _index.theme.color.supporting.dark.swatch,
            fontWeight: 600,
            marginLeft: (0, _index.pxToEm)(25)
          },
          // hide menus on large displays
          '& .menu': {
            '& .menugroup': {
              '&.name-pageitems': {
                display: 'none'
              },
              '&.name-logoutitems': {
                display: 'none'
              },
              '& .menutitle': {
                display: 'none'
              }
            }
          }
        }
      }
    }
  }
}, "@media only screen and (min-width:".concat((0, _index.pxToEm)(0), ") and (max-width:").concat((0, _index.pxToEm)(1000), ")"), {
  header: {
    justifyContent: 'space-between',
    '& > .group': {
      // +++++ navs +++++ //
      '&.name-navs': {
        flex: '0',
        // topnav
        '& .name-sections': {
          display: 'none'
        },
        // account
        '& .name-account': {
          '& .menu': {
            '& .menuitems': {
              left: 'auto',
              right: (0, _index.pxToEm)(-112),
              '& .arrow': {
                alignSelf: 'flex-end',
                marginRight: (0, _index.pxToEm)(10)
              }
            },
            '& .menugroup': {
              '&.name-pageitems': {
                display: 'block'
              },
              '&.name-logoutitems': {
                display: 'block'
              },
              '& .menutitle': {
                display: 'block'
              }
            }
          },
          '& .link.name-logout': {
            display: 'none'
          }
        }
      }
    }
  }
});

exports.default = _default;